import axios from 'axios';
import store from '@/store';
import TokenService from '@/core/services/token.service';

const $http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URI_API,
    responseType: 'json',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
 });

// La cabecera se añade en cada petición, no una sola vez al iniciar sesión.
// Antes vivía en `$http.defaults` y se perdía al recargar la página, de modo
// que la aplicación quedaba apoyada únicamente en la cookie de sesión.
$http.interceptors.request.use(
    (config: any) => {
        const token = TokenService.get();
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
);

$http.interceptors.response.use(
    (config: any) => config,
    (err: any) => {
        if (!err.response) {
            return Promise.reject(err);
        }

        // 401: el servidor rechaza el token guardado. Lo descartamos y
        // reintentamos una única vez sin cabecera. En DRF la autenticación se
        // resuelve antes que los permisos, así que un token inválido rompe
        // incluso los endpoints AllowAny: sin este reintento, un token muerto
        // dejaría al cliente final sin las pantallas públicas.
        const sentToken = !!(err.config.headers && err.config.headers.Authorization);

        if (err.response.status === 401 && sentToken && !err.config.__retriedWithoutToken) {
            TokenService.clear();
            store.dispatch('authLogout');
            err.config.__retriedWithoutToken = true;
            delete err.config.headers.Authorization;
            return $http.request(err.config);
        }

        // 403 sin credenciales que enviar significa sesión caducada: se cierra
        // sesión, que es como la aplicación acaba en el login. Si sí había
        // token, el 403 es una cuestión de permisos (p. ej. SyncPermission) o
        // de una ruta pública llamando a un endpoint privado, y cerrar sesión
        // sería incorrecto: antes echaba al usuario fuera sin explicación.
        if (err.response.status === 403 && !TokenService.get()) {
            store.dispatch('authLogout');
        }

        return Promise.reject(err);
    },
);

export default $http;
